import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { id: "main-content" }
const _hoisted_2 = {
  key: 0,
  class: "container"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { id: "alert-banner-content" }, null, -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  id: "modal",
  class: "modal-container"
}, null, -1 /* HOISTED */)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NavSidebarComponent = _resolveComponent("NavSidebarComponent")
  const _component_BreadcrumbsComponent = _resolveComponent("BreadcrumbsComponent")
  const _component_PageLoaderComponent = _resolveComponent("PageLoaderComponent")
  const _component_router_view = _resolveComponent("router-view")
  const _component_SidebarWrapperComponent = _resolveComponent("SidebarWrapperComponent")
  const _component_AlertBannerComponent = _resolveComponent("AlertBannerComponent")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NavSidebarComponent, { "show-nav": $options.show_nav }, null, 8 /* PROPS */, ["show-nav"]),
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", {
        id: "page",
        class: _normalizeClass([ 'page', { 'page--no-padding' : $options.is_login_route } ])
      }, [
        (!$options.is_login_route)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_BreadcrumbsComponent)
            ]))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_router_view, null, {
          default: _withCtx(({ Component }) => [
            _createVNode(_Transition, { name: "fade" }, {
              default: _withCtx(() => [
                ($data.loading)
                  ? (_openBlock(), _createBlock(_component_PageLoaderComponent, { key: 0 }))
                  : (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                      key: 1,
                      onLoggedIn: $options.fetchInitialData,
                      onOptionApproved: $options.showApprovalsSidebar,
                      onRevisionApproved: $options.showApprovalsSidebar,
                      onLeaveCommentAtTimestamp: _ctx.startNewCommentsAtTimestamp
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, ["onLoggedIn", "onOptionApproved", "onRevisionApproved", "onLeaveCommentAtTimestamp"]))
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */)
          ]),
          _: 1 /* STABLE */
        })
      ], 2 /* CLASS */),
      _withDirectives(_createVNode(_component_SidebarWrapperComponent, { ref: "sidebar-wrapper" }, null, 512 /* NEED_PATCH */), [
        [_vShow, !$options.is_login_route]
      ]),
      _createVNode(_component_AlertBannerComponent, null, {
        content: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1 /* STABLE */
      }),
      _hoisted_4
    ])
  ], 64 /* STABLE_FRAGMENT */))
}